import React from 'react';
import PropTypes from 'prop-types';

import {
  ENTITY_TYPE_PERFORMER,
  ENTITY_TYPE_CATEGORY,
  ENTITY_TYPE_GROUPING,
  ENTITY_TYPE_GEO,
  ENTITY_TYPE_VENUE,
} from '@stubhub/entity-helper';

import ChildSeoLinksLazyLoad from '../../../modules/react-child-seo-links/container';

import {titles} from './messages';

const SEOLinkEntities = [ENTITY_TYPE_CATEGORY, ENTITY_TYPE_GROUPING, ENTITY_TYPE_PERFORMER];
const PERFORMER_RESULTS_PER_PAGE = 60;
const DEFAULT_RESULTS_PER_PAGE = 500;

/**
 * Child Entities Mapping for the Parent Entity.
 *
 */
const childSEOTypesForParent = {
  [ENTITY_TYPE_GROUPING]: SEOLinkEntities.slice(1).reverse(),
  [ENTITY_TYPE_CATEGORY]: SEOLinkEntities,
};

/**
 * Method to the get the Display Title for the Current Entity Type;
 * @param title [string] The Entity type constant value from `utils/catalog`.
 * @returns displayTitle [string] The localized string title value for the given entity type.
 *
 */
const getDisplayTitle = (title) => titles[title] || '';

class EntitiesSeoLinks extends React.PureComponent {
  render() {
    const {className, parentEntityType, entityId, namespace, disableNoLinksFoundMessage, hideSEOLinks} = this.props;
    let {entityType = []} = this.props;

    /**
     * If Entity Type is a String then convert to Array with single entry to be used by the render Section
     *
     */
    if (typeof entityType === 'string') {
      entityType = [entityType];
    }

    return (
      <div className="EntitiesSeoLinks__Container">
        {(entityType.length ? entityType : childSEOTypesForParent[parentEntityType] || []).map((SEOLinkEntity) => {
          const apiParams = {};

          /**
           * Search Spec for `parentEntityType` CATEGORY
           *
           */
          if (parentEntityType === ENTITY_TYPE_CATEGORY) {
            if (SEOLinkEntity === ENTITY_TYPE_CATEGORY) {
              apiParams.parentId = entityId;
            } else if (SEOLinkEntity === ENTITY_TYPE_GROUPING) {
              apiParams.parentId = 0;
              apiParams[`${parentEntityType}Id`] = entityId;
            }
          }

          /**
           * Search Spec for `parentEntityType` GROUPING
           *
           */
          // Rationale: Haven't find situation where grouping is a parent to an category entity
          if (parentEntityType === ENTITY_TYPE_GROUPING) {
            if (SEOLinkEntity === ENTITY_TYPE_GROUPING) {
              apiParams.parentId = entityId;
            } /* istanbul ignore next */ else if (SEOLinkEntity === ENTITY_TYPE_CATEGORY) {
              return Promise.resolve({});
            }
          }

          /**
           * Search Spec for `parentEntityType` GEOGRAPHY
           *
           */
          if (parentEntityType === ENTITY_TYPE_GEO) {
            apiParams.sort = 'name asc';
            apiParams.start = 0;
            apiParams.rows = 500;
            if (SEOLinkEntity === ENTITY_TYPE_VENUE) {
              apiParams.geoId = entityId;
            } else if (SEOLinkEntity === ENTITY_TYPE_GEO) {
              apiParams.parentId = entityId;
            }
          }

          const isPerformer = SEOLinkEntity === ENTITY_TYPE_PERFORMER;

          /**
           * Search Spec for `entityType` PERFORMER.
           *
           */
          if (isPerformer) {
            apiParams.sort = 'title';
            apiParams[`${parentEntityType}Id`] = entityId;
          }

          const componentNamespace = `${namespace}.${SEOLinkEntity}`;

          return (
            <ChildSeoLinksLazyLoad
              key={componentNamespace}
              namespace={componentNamespace}
              className={className}
              entityType={SEOLinkEntity}
              entityId={entityId}
              apiParams={apiParams}
              title={getDisplayTitle(SEOLinkEntity)}
              showPagination={isPerformer}
              resultsPerPage={isPerformer ? PERFORMER_RESULTS_PER_PAGE : DEFAULT_RESULTS_PER_PAGE}
              disableNoLinksFoundMessage={disableNoLinksFoundMessage}
              hideSEOLinks={hideSEOLinks}
            />
          );
        })}
      </div>
    );
  }
}

EntitiesSeoLinks.contextTypes = {
  queue: PropTypes.object,
};

EntitiesSeoLinks.propTypes = {
  /**
   * The Entity under which the current child SEO links are shown
   *
   */
  parentEntityType: PropTypes.string,

  /**
   * The ID of the Entity of the parent which should be used in the search specification.
   *
   */
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,

  /**
   * Parent Namespace
   *
   */
  namespace: PropTypes.string.isRequired,

  /**
   * Entity Type Child SEO Links to be Displayed for the Current Parent Entity.
   *
   */
  entityType: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /**
   * Flag to Disable the Message Shown when links are not are not Available
   *
   */
  disableNoLinksFoundMessage: PropTypes.bool,

  /**
   * Flag to hide the SEO Links from rendering
   *
   */
  hideSEOLinks: PropTypes.bool,
};

export default EntitiesSeoLinks;
